<div class="main-container">
    <div class="modal-header">
        <span class="modal-main-title">{{data.title.key | translate}}</span>
        <img src="../../../assets/svg/close-button.svg" class="modal-close-btn" (click)="close(false);$event.stopPropagation()">
    </div>
    <div class="modal-body" (click)="$event.stopPropagation()">
        <div class="frequencie-container">
            <span class="frequencies-container-title">{{data.subtitle.key | translate}}</span>
            <div *ngFor="let frequency of data.frequencies" 
                class="frequencie"                 
                [ngClass]="{'active': frequency.uuid === selectedFrequency}"
                (click)="setFrequency(frequency.uuid)">
                <p-radioButton 
                    [value]="frequency.uuid" 
                    [label]="(frequency.name | titlecase)"
                    [(ngModel)]="selectedFrequency"></p-radioButton>            
                <div *ngIf="frequency.slug === '14_days'" class="recomended-container">
                    <span>{{'project_team_frequency_recomanded' | translate}}</span>
                </div>
            </div>
        </div>
        <div class="note-container">
            <i class="bi bi-question-circle-fill text-warning dn-question-icon"></i>
            <span class="note-text">{{data.warning.key | translate}}</span>
        </div>
        <div class="buttons-container">
            <button pButton [ngClass]="button.className" [label]="(button.labelKey | translate)" *ngFor="let button of data.buttons" (click)="close(button.value);$event.stopPropagation()"></button>
        </div>
    </div>
</div>